import { Component } from '@angular/core';
import { membersuiteProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteproduct-form',
    templateUrl: './membersuiteproduct.form.component.html'
})
export class membersuiteProductFormComponent extends BaseFormComponent {
    public record!: membersuiteProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

